import ManagePayroll from '../../../views/Personnel/Payroll/ManagePayroll.payroll.view';

export default ManagePayroll;
